export var intialStateEvents = {
    summary: {},
    alert: {},
    milestone: {},
    sos: {},
    fallDetection: {},
    isRenderLocation: true,
    facilitySummary: [],
    wellnessPlan: {},
    assessment: {},
};
